// Утилита для расчёта кэша городов
import {checkIfSpecialBuilding} from "../buildings/checkIfSpecialBuilding";
import {calculateCitiesCache} from "./calculateCitiesCache";
import {CONSTRUCTION_ACTION_TYPES} from "../../constants/construction";

export const calculateFutureCitiesCache = (hexes, specialBuildings, pendingBuildings) => {
  const futureHexes = {...hexes};
  const futureSpecialBuildings = {...specialBuildings};

  for (const building of pendingBuildings) {
    const {
      type,
      hexKey,
      token,
    } = building

    if (type === CONSTRUCTION_ACTION_TYPES.BUILDING_REPAIRMENT) {
      continue;
    }

    if (checkIfSpecialBuilding(token)) {
      futureSpecialBuildings[hexKey] = token;
    } else {
      futureHexes[hexKey] = token;
    }
  }

  return calculateCitiesCache(futureHexes, futureSpecialBuildings);
};